import React, { FC } from 'react'

import { GenreWithCurators } from 'src/Redux/spotifyCampaignGenresApi'

import { SearchGenresList } from './SearchGenresList'
import { RecommendedGenresList } from './RecomendedGenresList'
import { AllGenresList } from './AllGenresList'

type SpotifyGenresModalReadyToSelectListsProps = {
  debouncedSearchValue: string
  onSetSelectedGenres: (genre: GenreWithCurators) => void
  selectedGenres: GenreWithCurators[]
  data: {
    allGenres?: GenreWithCurators[]
    recommended?: GenreWithCurators[]
    filteredAllGenres?: GenreWithCurators[]
  }
}
export const SpotifyGenresModalReadyToSelectLists: FC<
  SpotifyGenresModalReadyToSelectListsProps
> = (props) => {
  const { debouncedSearchValue, selectedGenres, data, onSetSelectedGenres } =
    props
  return (
    <>
      {Boolean(debouncedSearchValue) && (
        <SearchGenresList
          searchValue={debouncedSearchValue}
          selectedGenres={selectedGenres}
          genres={data?.allGenres}
          onClickGenre={onSetSelectedGenres}
        />
      )}
      {!debouncedSearchValue && (
        <RecommendedGenresList
          selectedGenres={selectedGenres}
          genres={data?.recommended}
          onClickGenre={onSetSelectedGenres}
        />
      )}
      {!debouncedSearchValue && (
        <AllGenresList
          selectedGenres={selectedGenres}
          genres={data?.filteredAllGenres}
          onClickGenre={onSetSelectedGenres}
        />
      )}
    </>
  )
}
